module.exports = __webpack_public_path__ + "img/symbol_0.48600b82.png";